export function permissions({ next, to, router, store }) {
  const authUser = store.getters.authUser;

  if (to.meta.permissions && to.meta.permissions.length > 0) {
    if (!authUser) return router.replace("/login");

    let hasPermission = true;

    to.meta.permissions.forEach(permission => {
      if (!authUser.permissions.includes(permission)) {
        hasPermission = false;
      }
    });

    if (!hasPermission) {
      return router.replace("/403");
    }
  }

  next();
}
